import instance from './instance';

export const fetchWorkspaceTemplates = params => instance.get('/workspace_templates', { params });

export const updateWorkspaceTemplate = (id, params) => instance.put(`/workspace_templates/${id}`, params);

export const deleteWorkspaceTemplate = id => instance.delete(`/workspace_templates/${id}`);
